<template>
    <div>

        <!-- 封面區域 -->
        <div class="cover-bg" :style="$tools.style.imgCover($config.checkURL('pic',cropperiod_data.project_pic))">
            <b-row class="proj-cover body-top-full justify-content-md-center" align-v="center">
                <b-col md="5" class="text-center">
                    <div class="proj-logo-area">
                        <h2>{{ cropperiod_data.project_name }} {{ cropperiod_data.name }}</h2>

                        <!-- 月報標題 -->
                        <h2 class="text-center">
                            <div class="block-text">{{ getDateMonth }}</div>
                            生長期預測報告
                        </h2>

                        <h5 class="text-center">
                            {{ log_time[0] }} ~
                            <span v-if="log_time[1]">{{ log_time[1] }}</span>
                        </h5>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div class="print-background">

            <div v-if="report_data">
                <div class="report-area">

                    <b-row>
                        <b-col cols="12" xl="3" md="4" sm="4">
                            <img  class="cropperiod-img" alt="cropperiods photo" :src="$config.checkURL('cropperiod', cropperiod_data.pic)" />
                        </b-col>
                        <b-col cols="12" xl="9" md="8" sm="8">
                            <div>
                                <h1>{{ cropperiod_data.name }}</h1>

                                <div class="growth-predict-info">
                                    <!-- 種植天數 -->
                                    <div class="emphasis-block" v-if="report_data.progress">
                                        <div class="emphasis-block-title">{{ $t('menu.days_after_planting') }}</div>
                                        
                                        <div class="emphasis-block-body"> {{ report_data.progress.day_count }} </div>
                                        {{ $t('u.days') }}
                                    </div>

                                    <!-- 生長階段 -->
                                    <div class="emphasis-block" v-if="report_data.current_stage_info.stage_name">
                                        <div class="emphasis-block-title">{{ $t('menu.current_growth_stage') }}</div>
                                        <div class="emphasis-block-body">
                                            {{ report_data.current_stage_info.stage_name[ language ] }}
                                            <!-- {{ report_data.current_stage_info.current_percentage }}% -->
                                        </div>
                                    </div>

                                    <!-- 下一個生長階段 -->
                                    <div class="emphasis-block" v-if="report_data.current_stage_info.next_stage_name && report_data.current_stage_info.days_to_next_stage">
                                        <div class="emphasis-block-title">{{ $t('menu.days_to_next_stage') }}</div>
                                        <div class="emphasis-block-body">
                                            {{ report_data.current_stage_info.next_stage_name[ language ] }}
                                            {{ report_data.current_stage_info.days_to_next_stage }}
                                        </div>
                                        {{ $t('u.days') }}
                                    </div>

                                    <!-- 採收預測期 -->
                                    <div class="emphasis-block" v-if="report_data.harvest_range">
                                        <div class="emphasis-block-title">
                                            {{ $t('menu.harvest_prediction') }}
                                        </div>
                                        <div class="emphasis-block-body">
                                            {{ report_data.harvest_range.min_harvest_date }} ~ {{ report_data.harvest_range.max_harvest_date }}
                                        </div>
                                        <!-- <CalendarHarvestChart :chartID="'harvest-predict-calendar'" :data="report_data.harvest_range"></CalendarHarvestChart> -->
                                    </div>

                                    
                                </div>

                                
                                <!-- Print & Share Link -->
                                <div class="block-text print-hide-object">
                                    <!-- <BtnSavePDF v-if="user != undefined && user.id != undefined && getToken != undefined" -->
                                    <BtnSavePDF
                                                :save_id="'print-page-top'"
                                                :save_type="'PDF'"
                                                :save_filename="'生長期預測'"
                                                :save_preview="false"
                                                :log_detail="getLogDetail"
                                                :btn_text="$t('menu.download')"
                                                btn_style="btn-cp" :btn_variant="'outline-warning'" :show_tooltip="false">
                                    </BtnSavePDF>
                                </div>

                            </div>
                        </b-col>
                    </b-row>

                </div>

                <div class="report-area">
                    <GrowthPredictChart :chartID="'growth-predict'" :data="report_data"></GrowthPredictChart>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import { mapState }         from 'vuex'
import ReportCover          from '@/views/project/report/components/ReportCover'
import CalendarHarvestChart from '@/views/project/report/components/Growth_Predict/Chart_CalendarHarvest'
import GrowthPredictChart   from '@/views/project/report/components/Growth_Predict/Chart_GrowthPredict'
// import DiaryTimeLine        from '@/views/project/report/components/Growth_Predict/TimeLine_Diary'
import BtnSavePDF from '@/views/components/Button_SavePDF'

export default {
    props: {
        user: {
            type: Object,
            default: undefined,
        },

    },
    components: {
        ReportCover,
        CalendarHarvestChart,
        GrowthPredictChart,
        // DiaryTimeLine,
        BtnSavePDF,
    },
    data () {
        return {
            date_month: '',
            date_range: '',
            report_data: undefined,
            report_url: '',
            report_save_name: '',
            log_time: [ '2019-01-23', '2020-05-01' ],

            cropperiod_data: {
                id: 115,
                uuid: '0a88bc4e-4931-4ef8-945b-a00440c7ffd3',
                name: '神之米 2020 一期',
                farm_field: '',
                description: '',
                start_date: '2020-01-22',
                end_date: '',
                pic: 'https://storage.googleapis.com/turtwig-cloud-storage/cropperiods/pics/0a88bc4e-4931-4ef8-945b-a00440c7ffd3.jpg',
                project_pic: 'https://storage.googleapis.com/turtwig-cloud-storage/projects/pics/cb235360-1a9a-4cb8-936a-4d44b43f9a21.jpg',
                project_name: '奧丁丁_池上禾穀坊',
                crop_info: '水稻',

            },
            
            testData: {
    "current_stage_info": {
        "days_to_next_stage": 4,
        "next_stage_code": "bbch_4_cereals",
        "next_stage_name": {
            "en": "Booting",
            "jp": "",
            "zh-Hant-CN": "",
            "zh-Hant-TW": "孕穗期"
        },
        "stage_code": "panicle_formation",
        "stage_name": {
            "en": "Panicle Formation",
            "jp": "",
            "zh-Hant-CN": "",
            "zh-Hant-TW": "幼穗期"
        }
    },
    "daily_progress": [
        [
            "2020-01-23",
            0.309
        ],
        [
            "2020-01-24",
            0.626
        ],
        [
            "2020-01-25",
            0.928
        ],
        [
            "2020-01-26",
            1.254
        ],
        [
            "2020-01-27",
            1.624
        ],
        [
            "2020-01-28",
            2.053
        ],
        [
            "2020-01-29",
            2.485
        ],
        [
            "2020-01-30",
            2.633
        ],
        [
            "2020-01-31",
            2.808
        ],
        [
            "2020-02-01",
            2.931
        ],
        [
            "2020-02-02",
            3.164
        ],
        [
            "2020-02-03",
            3.558
        ],
        [
            "2020-02-04",
            4.057
        ],
        [
            "2020-02-05",
            4.448
        ],
        [
            "2020-02-06",
            4.963
        ],
        [
            "2020-02-07",
            5.471
        ],
        [
            "2020-02-08",
            5.793
        ],
        [
            "2020-02-09",
            6.041
        ],
        [
            "2020-02-10",
            6.345
        ],
        [
            "2020-02-11",
            6.733
        ],
        [
            "2020-02-12",
            7.273
        ],
        [
            "2020-02-13",
            7.912
        ],
        [
            "2020-02-14",
            8.594
        ],
        [
            "2020-02-15",
            9.311
        ],
        [
            "2020-02-16",
            9.727
        ],
        [
            "2020-02-17",
            9.802
        ],
        [
            "2020-02-18",
            9.873
        ],
        [
            "2020-02-19",
            10.178
        ],
        [
            "2020-02-20",
            10.599
        ],
        [
            "2020-02-21",
            11.062
        ],
        [
            "2020-02-22",
            11.662
        ],
        [
            "2020-02-23",
            12.162
        ],
        [
            "2020-02-24",
            12.772
        ],
        [
            "2020-02-25",
            13.468
        ],
        [
            "2020-02-26",
            14.115
        ],
        [
            "2020-02-27",
            14.641
        ],
        [
            "2020-02-28",
            15.232
        ],
        [
            "2020-02-29",
            15.943
        ],
        [
            "2020-03-01",
            16.714
        ],
        [
            "2020-03-02",
            17.208
        ],
        [
            "2020-03-03",
            17.767
        ],
        [
            "2020-03-04",
            18.357
        ],
        [
            "2020-03-05",
            18.734
        ],
        [
            "2020-03-06",
            19.215
        ],
        [
            "2020-03-07",
            19.841
        ],
        [
            "2020-03-08",
            20.54
        ],
        [
            "2020-03-09",
            21.32
        ],
        [
            "2020-03-10",
            21.793
        ],
        [
            "2020-03-11",
            22.111
        ],
        [
            "2020-03-12",
            22.621
        ],
        [
            "2020-03-13",
            23.333
        ],
        [
            "2020-03-14",
            23.744
        ],
        [
            "2020-03-15",
            23.984
        ],
        [
            "2020-03-16",
            24.337
        ],
        [
            "2020-03-17",
            24.698
        ],
        [
            "2020-03-18",
            25.225
        ],
        [
            "2020-03-19",
            25.936
        ],
        [
            "2020-03-20",
            26.491
        ],
        [
            "2020-03-21",
            27.249
        ],
        [
            "2020-03-22",
            28.073
        ],
        [
            "2020-03-23",
            28.833
        ],
        [
            "2020-03-24",
            29.48
        ],
        [
            "2020-03-25",
            30.217
        ],
        [
            "2020-03-26",
            31.021
        ],
        [
            "2020-03-27",
            31.846
        ],
        [
            "2020-03-28",
            32.514
        ],
        [
            "2020-03-29",
            32.978
        ],
        [
            "2020-03-30",
            33.578
        ],
        [
            "2020-03-31",
            34.233
        ],
        [
            "2020-04-01",
            34.806
        ],
        [
            "2020-04-02",
            35.354
        ],
        [
            "2020-04-03",
            35.978
        ],
        [
            "2020-04-04",
            36.573
        ],
        [
            "2020-04-05",
            36.982
        ],
        [
            "2020-04-06",
            37.354
        ],
        [
            "2020-04-07",
            37.907
        ],
        [
            "2020-04-08",
            38.436
        ],
        [
            "2020-04-09",
            38.934
        ],
        [
            "2020-04-10",
            39.514
        ],
        [
            "2020-04-11",
            40.142
        ],
        [
            "2020-04-12",
            40.538
        ],
        [
            "2020-04-13",
            40.99
        ],
        [
            "2020-04-14",
            41.434
        ],
        [
            "2020-04-15",
            41.961
        ],
        [
            "2020-04-16",
            42.488
        ],
        [
            "2020-04-17",
            43.177
        ],
        [
            "2020-04-18",
            43.938
        ],
        [
            "2020-04-19",
            44.807
        ],
        [
            "2020-04-20",
            45.598
        ],
        [
            "2020-04-21",
            46.44
        ],
        [
            "2020-04-22",
            47.055
        ],
        [
            "2020-04-23",
            47.549
        ],
        [
            "2020-04-24",
            48.031
        ],
        [
            "2020-04-25",
            48.576
        ],
        [
            "2020-04-26",
            49.294
        ],
        [
            "2020-04-27",
            49.884
        ],
        [
            "2020-04-28",
            50.454
        ],
        [
            "2020-04-29",
            51.042
        ],
        [
            "2020-04-30",
            51.757
        ],
        [
            "2020-05-01",
            52.525
        ],
        [
            "2020-05-02",
            53.296
        ],
        [
            "2020-05-03",
            54.03
        ],
        [
            "2020-05-04",
            54.789
        ],
        [
            "2020-05-05",
            55.572
        ],
        [
            "2020-05-06",
            56.419
        ],
        [
            "2020-05-07",
            57.278
        ],
        [
            "2020-05-08",
            58.133
        ],
        [
            "2020-05-09",
            59.001
        ],
        [
            "2020-05-10",
            59.839
        ],
        [
            "2020-05-11",
            60.622
        ],
        [
            "2020-05-12",
            61.437
        ],
        [
            "2020-05-13",
            62.324
        ],
        [
            "2020-05-14",
            63.217
        ],
        [
            "2020-05-15",
            64.091
        ],
        [
            "2020-05-16",
            64.932
        ],
        [
            "2020-05-17",
            65.766
        ],
        [
            "2020-05-18",
            66.614
        ],
        [
            "2020-05-19",
            67.471
        ],
        [
            "2020-05-20",
            68.295
        ],
        [
            "2020-05-21",
            69.165
        ],
        [
            "2020-05-22",
            70.039
        ],
        [
            "2020-05-23",
            70.9
        ],
        [
            "2020-05-24",
            71.753
        ],
        [
            "2020-05-25",
            72.627
        ],
        [
            "2020-05-26",
            73.512
        ],
        [
            "2020-05-27",
            74.438
        ],
        [
            "2020-05-28",
            75.365
        ],
        [
            "2020-05-29",
            76.272
        ],
        [
            "2020-05-30",
            77.207
        ],
        [
            "2020-05-31",
            78.134
        ],
        [
            "2020-06-01",
            79.052
        ],
        [
            "2020-06-02",
            79.948
        ],
        [
            "2020-06-03",
            80.895
        ],
        [
            "2020-06-04",
            81.855
        ],
        [
            "2020-06-05",
            82.817
        ],
        [
            "2020-06-06",
            83.779
        ],
        [
            "2020-06-07",
            84.748
        ],
        [
            "2020-06-08",
            85.708
        ],
        [
            "2020-06-09",
            86.693
        ],
        [
            "2020-06-10",
            87.625
        ],
        [
            "2020-06-11",
            88.51
        ],
        [
            "2020-06-12",
            89.388
        ],
        [
            "2020-06-13",
            90.254
        ],
        [
            "2020-06-14",
            91.129
        ],
        [
            "2020-06-15",
            92.076
        ],
        [
            "2020-06-16",
            93.045
        ],
        [
            "2020-06-17",
            94.037
        ],
        [
            "2020-06-18",
            95.027
        ],
        [
            "2020-06-19",
            96.007
        ],
        [
            "2020-06-20",
            96.982
        ],
        [
            "2020-06-21",
            97.974
        ],
        [
            "2020-06-22",
            98.993
        ],
        [
            "2020-06-23",
            100.0
        ]
    ],
    "growth_predict": [
        {
            "code": "bbch_1_rice",
            "end_date": "2020-02-22",
            "name": {
                "en": "Leaf Development",
                "jp": "",
                "zh-Hant-CN": "",
                "zh-Hant-TW": "成活期"
            },
            "period": [
                30,
                0
            ],
            "start_date": "2020-01-23"
        },
        {
            "code": "bbch_2_cereals",
            "end_date": "2020-04-07",
            "name": {
                "en": "Tillering",
                "jp": "",
                "zh-Hant-CN": "",
                "zh-Hant-TW": "分蘗期"
            },
            "period": [
                45,
                0
            ],
            "start_date": "2020-02-22"
        },
        {
            "code": "panicle_formation",
            "end_date": "2020-05-05",
            "name": {
                "en": "Panicle Formation",
                "jp": "",
                "zh-Hant-CN": "",
                "zh-Hant-TW": "幼穗期"
            },
            "period": [
                24,
                5
            ],
            "start_date": "2020-04-07"
        },
        {
            "code": "bbch_4_cereals",
            "end_date": "2020-05-16",
            "name": {
                "en": "Booting",
                "jp": "",
                "zh-Hant-CN": "",
                "zh-Hant-TW": "孕穗期"
            },
            "period": [
                0,
                11
            ],
            "start_date": "2020-05-05"
        },
        {
            "code": "bbch_5_cereals",
            "end_date": "2020-05-26",
            "name": {
                "en": "Heading",
                "jp": "",
                "zh-Hant-CN": "",
                "zh-Hant-TW": "抽穗期"
            },
            "period": [
                0,
                10
            ],
            "start_date": "2020-05-16"
        },
        {
            "code": "ripening_cereals",
            "end_date": "2020-06-23",
            "name": {
                "en": "Ripening",
                "jp": "",
                "zh-Hant-CN": "",
                "zh-Hant-TW": "成熟期"
            },
            "period": [
                0,
                28
            ],
            "start_date": "2020-05-26"
        }
    ],
    "harvest_range": {
        "max_days": 161,
        "max_harvest_date": "2020-07-02",
        "min_days": 145,
        "min_harvest_date": "2020-06-16"
    },
    "max_date": "2020-07-02",
    "min_date": "2020-01-19",
    "progress": {
        "day_count": 99,
        "end_date": "2020-05-01",
        "start_date": "2020-01-23"
    },
    "work_advice": [
        {
            "advice_work": [
                "基肥"
            ],
            "date": "2020-01-19"
        },
        {
            "advice_work": [
                "病蟲害預防"
            ],
            "date": "2020-01-23"
        },
        {
            "advice_work": [
                "穗肥"
            ],
            "date": "2020-04-17"
        }
    ]
            },

        }
    },
    mounted ()
    {
        this.arrangeData( this.testData )
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
        }),

        getDateMonth ()
        {
            let _report_date_range = undefined

            // 報告月份 - 取第一隻感測器的開始日期來判斷月報顯示名稱
            if (this.log_time.length > 0)
            {
                _report_date_range = this.log_time[0]
            }
            else return undefined
            
            if (_report_date_range != undefined)
            {
                let _moment_lang = ( this.user_language ? this.$moment( _report_date_range ).locale( this.user_language ) : undefined )
                
                if (_moment_lang != undefined)
                {
                    return this.$t( 'date.months.' + _moment_lang.format('MMMM') )
                }
            }

            return undefined
        },

        getToken ()
        {
            return localStorage.token
        },

        getLogDetail ()
        {
            return {
                page: 'report monthly predict',
                action: 'download pdf',
                querySettings: {
                    'project ID':       this.cropperiod_data.project_id,
                    'cropperiod ID':    this.cropperiod_data.id,
                    'cropperiod name':  this.cropperiod_data.name,
                    'report name':      this.date_month + ' 生長期預測', //+ this.$t('menu.analysis_report'),
                    'report type':      'monthly',
                    'report range':     this.date_range,
                    'report ID':        this.$route.query.id,
                    'report url':       this.report_url,
                },
                pageInfo: {
                    'project timezone':     this.cropperiod_data.project_timezone,
                    'project status':       this.cropperiod_data.project_status,
                },
            }
        },

    },
    methods: {

        arrangeData (_originalData)
        {
            this.report_data = undefined

            if ( _originalData )
            {
                // if ( _originalData.growth_predict )
                // {
                //     _originalData.growth_predict.forEach( _stage => {
                //         let _total_days = _stage.period[0] + _stage.period[1]
                //         _stage.end_date = this.$tools.date.getDateShift( _stage.start_date, _total_days, 'days', 'YYYY-MM-DD' )
                //     })
                // }

                this.report_data = _originalData
            }
        },

    },
}
</script>

<style lang="scss" scoped>

.report-title
{
    margin-top: 20px;
    margin-bottom: 30px;
}

.cropperiod-img
{
    width: 100%;
    max-height: 500px;
    margin-top: 5px;
    margin-bottom: 15px;
}

.emphasis-block-title
{
    font-size: 1.2rem;
}

</style>